import Api from "./base/api-base";

export default class DateEveryExcelApi {
  download (date) {
    return Api.get({
      endpoint: Api.endpoint.date_every_excel_download,
      id: date
    });
  }
}